import WebLLCRESTApi from "../api/api";
import $ from 'jquery';

export default {
  name: "PagedApiTable",
  
  created() {
    // prepare api
    this.api = new WebLLCRESTApi(this.module, this.$router);
    
    this.refresh(true);
  },
  
  props: {
    module: String,
    moduleId: String,
    customDataSource: Object,
    fields: Object,
    filter: Object,
    includeRelations: Array,
    defaultSort: String,
    columns: Array,
    perPage: Number,
    refreshForId: String,
    showTotalCount: Boolean
  },
  
  data() {
    return {
      isLoading: false,
      curPage: 0,
      totalPages: 0,
      totalCount: 0,
      curSort: null,
      bulkDeleteSelected: 0,
      multiDelete: false,
      navButtons: [],
      rows: []
    };
  },
  
  methods: {
    async getData(refreshPageCount) {
      if(this.customDataSource && typeof this.customDataSource == "string") {
        this.totalPages = 0;
        
        return [];
      }
      else if(this.customDataSource) {
        this.isLoading = true;
        const result = await this.customDataSource.getData(refreshPageCount, this.curPage, this.perPage, this.getCurrentSortFilter(), this.filter);
        this.isLoading = false;
        
        if(result.totalCount || result.totalCount === 0) {
          this.totalCount = result.totalCount;
          this.totalPages = Math.ceil(result.totalCount / this.perPage);
          
          this.refreshPageNavigation();
        }
        
        result.data.forEach(this.processItem);
        return result.data;
      }
      else {
        if(this.curPage < 0)
          this.curPage = 0;
        
        var fullFilter = {
          "offset": this.curPage * this.perPage,
          "order": this.getCurrentSortFilter(),
          "limit": this.perPage,
          "fields": this.fields,
          "where": this.filter,
          "include": this.includeRelations
        };
        
        this.isLoading = true;
        
        // we may need to update the page count
        if(refreshPageCount) {
          var tblCount = await this.api.countData(this.filter);
          this.totalCount = tblCount;
          this.totalPages = Math.ceil(tblCount / this.perPage);
          
          this.refreshPageNavigation();
        }
        
        const results = await this.api.getData(null, fullFilter);
        
        this.isLoading = false;
        
        results.forEach(this.processItem.bind(this));
        return results;
      }
    },
    
    processItem(item) {
      for(const column of this.columns) {
        if(column.fnAsyncLoad) {
          item[column.key] = column.fnAsyncLoad(item);
        }
      }
    },
    
    async refresh(refreshPageCount) {
      this.bulkDeleteSelected = 0;
      
      var data = await this.getData(refreshPageCount);
      
      // translate the data into the correct row->column mappings
      if(data && data.map) {
        this.rows = data.map((item, idx) => {
          return {
            item: item,
            index: idx,
            tblFormatted: this.columns.map((column) => {
              if(column.type == "String") {
                const finalItem = {
                  key: column.key,
                  type: "String",
                  text: (item[column.key].then ? "Loading..." : item[column.key])
                };
                
                if(item[column.key].then) {
                  item[column.key].then((text) => {
                    finalItem.text = text;
                  });
                }
                
                return finalItem;
              }
              else if(column.type == "Dropdown") {
                const finalItem = {
                  key: column.key,
                  type: "Dropdown",
                  text: item[column.key],
                  options: column.options
                };
                
                return finalItem;
              }
              else if(column.type == "URL") {
                return {
                  key: column.key,
                  type: "URL",
                  url: item[column.key]
                };
              }
              else if(column.type == "ImageOptions") {
                const finalItem = {
                  key: column.key,
                  type: "ImageOptions",
                  text: item[column.key],
                  editable: column.editable,
                  options: column.options
                };
                
                return finalItem;
              }
              else if(column.type == "Date") {
                const date = new Date(item[column.key]);
                
                return {
                  key: column.key,
                  type: "Date",
                  date: (item[column.key] ? this.toDateOnlyUTC(date) : "Not Set")
                };
              }
              else if(column.type == "DateTime") {
                return {
                  key: column.key,
                  type: "DateTime",
                  date: new Date(item[column.key])
                };
              }
              else if(column.type == "Boolean") {
                return {
                  key: column.key,
                  type: "Boolean",
                  value: item[column.key]
                };
              }
              else if(column.type == "!Boolean") {
                return {
                  key: column.key,
                  type: "Boolean",
                  value: !item[column.key]
                };
              }
              else if(column.type == "Event") {
                return {
                  key: column.key,
                  type: "Event",
                  text: (column.fnAsyncLoad ? column.fnAsyncLoad(item) : column.text)
                };
              }
              else if(column.type == "Route") {
                return {
                  key: column.key,
                  type: "Route",
                  path: this.translateRoute(column.route, item),
                  text: column.text
                };
              }
              else if(column.type == "Delete") {
                return {
                  key: column.key,
                  type: "Delete",
                  text: column.text,
                  id: column.id
                };
              }
              else if(column.type == "SoftDelete") {
                return {
                  key: column.key,
                  type: "SoftDelete",
                  text: column.text,
                  id: column.id
                };
              }
              else if(column.type == "BulkDelete") {
                return {
                  key: column.key,
                  type: "BulkDelete",
                  text: column.text,
                  selected: false
                };
              }
              else if(column.type == "BulkEvent") {
                return {
                  key: column.key,
                  type: "BulkEvent"
                };
              }
              else {
                return "Invalid";
              }
            })
          };
        });
      }
    },
    
    toDateOnlyUTC(date) {
      const monthNum = (date.getUTCMonth() + 1).toString();
      const dayNum = (date.getUTCDate()).toString();
      
      return "00".substring(0, 2 - monthNum.length) + monthNum
        + "/"
        + "00".substring(0, 2 - dayNum.length) + dayNum
        + "/"
        + date.getUTCFullYear();
    },
    
    refreshPageNavigation() {
      this.navButtons.splice(0, this.navButtons.length);
      
      this.navButtons.push({
        text: "First",
        page: 0,
        isCurrent: (0 == this.curPage)
      });
      
      if(this.curPage - 1 >= 0) {
        this.navButtons.push({
          text: "<",
          page: this.curPage - 1,
          isCurrent: false
        });
      }
      
      for(var index=this.curPage - 5; index<this.curPage; index++) {
        if(index >= 0) {
          this.navButtons.push({
            text: "" + (index + 1),
            page: index,
            isCurrent: false
          });
        }
      }
      
      this.navButtons.push({
        text: "" + (this.curPage + 1),
        page: this.curPage,
        isCurrent: true
      });
      
      for(var index=this.curPage + 1; index<=this.curPage + 5; index++) {
        if(index < this.totalPages) {
          this.navButtons.push({
            text: "" + (index + 1),
            page: index,
            isCurrent: false
          });
        }
      }
      
      if(this.curPage + 1 < this.totalPages) {
        this.navButtons.push({
          text: ">",
          page: this.curPage + 1,
          isCurrent: false
        });
      }
      
      this.navButtons.push({
        text: "Last",
        page: this.totalPages - 1,
        isCurrent: (this.totalPages - 1 == this.curPage)
      });
    },
    
    translateRoute(routePath, item) {
      return routePath.split("/").map((part) => {
        if(part.length > 0 && part.charAt(0) == ":") {
          return item[part.substring(1)];
        }
        else {
          return part;
        }
      }).join("/");
    },
    
    onItemClicked(item, col) {
      this.$emit('click', { item: item, col: col, rows: this.rows });
    },
    
    onItemUpdated(newValue, item, col) {
      this.$emit('itemUpdated', { newValue: newValue, item: item, col: col, rows: this.rows });
    },
    
    onItemDelete(item, col) {
      this.multiDelete = false;
      this.deleteInfo = {
        id: (this.moduleId ? item.item[this.moduleId] : item.item.id),
        softDelete: false,
        item: item.item             // this is the original item from the api
      };
      
      $(this.$refs.dlgDelete).modal('show');
    },
    
    onItemSoftDelete(item, col) {
      this.multiDelete = false;
      this.deleteInfo = {
        id: (this.moduleId ? item.item[this.moduleId] : item.item.id),
        softDelete: true,
        item: item.item             // this is the original item from the api
      };
      
      $(this.$refs.dlgDelete).modal('show');
    },
    
    async onDeleteConfirmed() {
      if(this.multiDelete == false) {
        if(this.deleteInfo.softDelete) {
          await this.api.updateData(this.deleteInfo.id, { deleted: true });
        }
        else {
          await this.api.deleteData(this.deleteInfo.id);
        }
      }
      else {
        for(var index=0; index<this.deleteInfo.itemIds.length; index++) {
          const itemId = this.deleteInfo.itemIds[index];
          
           if(this.deleteInfo.softDelete) {
            await this.api.updateData(this.deleteInfo.id, { deleted: true });
          }
          else {
            await this.api.deleteData(itemId);
          }
        }
      }
      
      this.refresh(true);
      
      $(this.$refs.dlgDelete).modal('toggle');
    },
    
    selectPage(page) {
      this.curPage = page;
      this.refresh(false);
      this.refreshPageNavigation();
    },
    
    bulkDeleteToggled(item) {
      if(item.selected) {
        this.bulkDeleteSelected--;
      }
      else {
        this.bulkDeleteSelected++;
      }
    },
    
    selectSort(column) {
      if(this.curSort && this.curSort.column == column.key && this.curSort.order == "ASC") {
        this.curSort = {
          column: column.key,
          order: "DESC"
        };
      }
      else {
        this.curSort = {
          column: column.key,
          order: "ASC"
        };
      }
      
      this.refresh(false);
    },
    
    getCurrentSortFilter() {
      if(this.curSort) {
        return this.curSort.column + " " + this.curSort.order;
      }
      else {
        return this.defaultSort;
      }
    },
    
    bulkDeleteToggleAll() {
      const newValue = (() => {
        if(this.bulkDeleteSelected == this.rows.length) {
          this.bulkDeleteSelected = 0;
          return false;
        }
        else {
          this.bulkDeleteSelected = this.rows.length;
          return true;
        }
      })();
      
      for(var index=0; index<this.rows.length; index++) {
        const row = this.rows[index];
        const formattedRow = row.tblFormatted;
        
        for(var cI=0; cI<formattedRow.length; cI++) {
          const col = formattedRow[cI];
          
          if(col.type == "BulkDelete") {
            col.selected = newValue;
          }
        }
      }
    },
    
    bulkEventClicked(col) {
      const items = this.rows.filter((row) => {
            const formattedRow = row.tblFormatted;
            
            for(var cI=0; cI<formattedRow.length; cI++) {
              const col = formattedRow[cI];
              
              if(col.type == "BulkDelete") {
                return col.selected;
              }
            }
            
            return false;
          });
      
      this.$emit('click', { items: items, col: col, rows: this.rows });
    },
    
    bulkDeleteClicked() {
      this.multiDelete = true;
      this.deleteInfo = {
        softDelete: false,
        itemIds: this.rows.filter((row) => {
            const formattedRow = row.tblFormatted;
            
            for(var cI=0; cI<formattedRow.length; cI++) {
              const col = formattedRow[cI];
              
              if(col.type == "BulkDelete") {
                return col.selected;
              }
            }
            
            return false;
          }).map((row) => (this.moduleId ? row.item[this.moduleId] : row.item.id))
      };
      
      $(this.$refs.dlgDelete).modal('show');
    }
  },
  
  computed: {
    allBulkDeleteSelected: {
      get() {
        return this.bulkDeleteSelected == this.rows.length;
      },
      set(newValue) { }
    },
    
    bulkEventColumns: {
      get() {
        return this.columns.filter((column) => column.type == "BulkEvent");
      }
    }
  },
  
  watch: {
    customDataSource(to, from) {
      this.refresh(true);
    },
    
    filter(to, from) {
      this.refresh(true);
    },
    
    perPage(to, from) {
      this.refresh(true);
    },
    
    refreshForId(to, from) {
      if(to) {
        this.refresh(true);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PagedApiTable.js